import { useUploadState } from '../lib/upload-manager.js'

/**
 * プロジェクト詳細でファイルをドラッグしている間、メイン領域に出す案内。
 *
 * メイン領域だけを覆い、サイドバーは覆わない。サイドバーのプロジェクトに落とすと
 * そちらへ入るので、覆ってしまうと受け口が見えず、「開いているプロジェクトに入る」
 * という案内も嘘になる。
 *
 * 見た目だけの要素なので pointer-events-none。ドロップの処理は upload-manager が行う。
 */
export function PageDropOverlay() {
  const { isDraggingFiles, pageDropTarget } = useUploadState()
  if (!isDraggingFiles || !pageDropTarget) return null

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center bg-primary/10 backdrop-blur-sm"
    >
      <div className="m-6 max-w-lg rounded-2xl border-4 border-dashed border-primary bg-card/95 px-10 py-14 text-center shadow-xl">
        <div className="mb-4 select-none text-6xl">⬇</div>
        <p className="text-lg font-semibold text-foreground">ここで離してアップロード</p>
        <p className="mt-1 break-all text-sm text-muted-foreground">
          「{pageDropTarget.projectName}」に追加されます
        </p>
        <p className="mt-4 text-xs text-muted-foreground">
          別のプロジェクトに入れるときは、サイドバーのプロジェクトの上で離してください
        </p>
      </div>
    </div>
  )
}
